import React, {useState} from 'react';
import {DataGrid, GridToolbarContainer, GridToolbarFilterButton, ruRU} from "@material-ui/data-grid";
import {makeStyles} from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import {Button} from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

const useStyles = makeStyles(() => ({
    table: {
        height: '100%',
        width: '100%'
    }
}))

const CustomToolbar = (props) => {
    const {onAddButtonClick, onDeleteButtonClick, disableDeleteButton} = props

    return <GridToolbarContainer>
        <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
            <Grid item>
                <GridToolbarFilterButton/>
            </Grid>
            <Grid item xs container alignItems={'center'} justifyContent={'flex-end'}>
                <Grid item>
                    <Button
                        size={'small'}
                        color={'primary'}
                        startIcon={<AddIcon/>}
                        onClick={onAddButtonClick}
                    >
                        Добавить
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        size={'small'}
                        color={'primary'}
                        startIcon={<DeleteOutlineIcon/>}
                        disabled={disableDeleteButton}
                        onClick={onDeleteButtonClick}
                    >
                        Удалить
                    </Button>
                </Grid>
            </Grid>

        </Grid>
    </GridToolbarContainer>
}

const HandbooksTable = (props) => {
    const {rows, columns, loading, onAddButtonClick, onRowDelete} = props

    const classes = useStyles()

    const [selectionModel, setSelectionModel] = useState([])

    const handleDeleteButtonClick = async () => {
        await onRowDelete(selectionModel)
    }

    return (
        <DataGrid rows={rows || []}
                  columns={columns}
                  className={classes.table}
                  components={{Toolbar: CustomToolbar}}
                  density={'compact'}
                  localeText={ruRU?.props?.MuiDataGrid?.localeText || ruRU?.components?.MuiDataGrid?.defaultProps?.localeText}
                  loading={loading}
                  disableColumnMenu
                  onSelectionModelChange={(selectionModel) => {
                      setSelectionModel(selectionModel)
                  }}
                  componentsProps={{
                      toolbar: {
                          onAddButtonClick: onAddButtonClick,
                          onDeleteButtonClick: handleDeleteButtonClick,
                          disableDeleteButton: selectionModel.length === 0
                      }
                  }}
        />
    );
};

export default HandbooksTable;